"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKET_ES = exports.MARKET_EN = exports.MARKET = void 0;
exports.MARKET = [
    {
        label: 'Agronegócio',
        value: 'agribusiness',
    },
    {
        label: 'Advocacia e Jurídico',
        value: 'advocacy',
    },
    {
        label: 'Alimentos e Bebidas',
        value: 'food',
    },
    {
        label: 'Consultoria',
        value: 'consultancy',
    },
    {
        label: 'Construção Civil',
        value: 'construction',
    },
    {
        label: 'Comunicação',
        value: 'communication',
    },
    {
        label: 'Educação e Ensino',
        value: 'education',
    },
    {
        label: 'Engenharia e Indústria Geral',
        value: 'engineering_industry',
    },
    {
        label: 'Engenharia',
        value: 'engineering',
    },
    {
        label: 'Eventos',
        value: 'events',
    },
    {
        label: 'Financeiro',
        value: 'financial',
    },
    {
        label: 'Entretenimento',
        value: 'entertainment',
    },
    {
        label: 'Governo e Órgãos Públicos',
        value: 'government',
    },
    {
        label: 'Games e Esportes',
        value: 'games_and_sports',
    },
    {
        label: 'Hardware e Eletrônicos',
        value: 'hardware',
    },
    {
        label: 'Tecnologia',
        value: 'technology',
    },
    {
        label: 'Jurídico e Relacionados',
        value: 'legal',
    },
    {
        label: 'Imobiliárias e Incorporadoras',
        value: 'real_estate',
    },
    {
        label: 'Industria e Manufatura',
        value: 'industry',
    },
    {
        label: 'Mídia e Comunicação',
        value: 'media',
    },
    {
        label: 'Meio Ambiente',
        value: 'environment',
    },
    {
        label: 'Moda',
        value: 'fashion',
    },
    {
        label: 'Mobilidade Urbana',
        value: 'urban_mobility',
    },
    {
        label: 'ONG / Terceiro Setor',
        value: 'non_government',
    },
    {
        label: 'Saúde e Medicina',
        value: 'health',
    },
    {
        label: 'Serviços Autônomos via Aplicativo',
        value: 'autonomous_app',
    },
    {
        label: 'Seguros',
        value: 'insurance',
    },
    {
        label: 'Serviços em RH e Coaching',
        value: 'human_resources_and_coaching',
    },
    {
        label: 'Telecomunicações',
        value: 'telecommunications',
    },
    {
        label: 'Turismo e Lazer',
        value: 'tourism',
    },
    {
        label: 'Varejo',
        value: 'retail',
    },
    {
        label: 'Outro',
        value: 'other',
    },
];
exports.MARKET_EN = [
    {
        label: 'Agribusiness',
        value: 'agribusiness',
    },
    {
        label: 'Advocacy and Legal',
        value: 'advocacy',
    },
    {
        label: 'Food',
        value: 'food',
    },
    {
        label: 'Consultancy',
        value: 'consultancy',
    },
    {
        label: 'Construction',
        value: 'construction',
    },
    {
        label: 'Communication',
        value: 'communication',
    },
    {
        label: 'Education and Teaching',
        value: 'education',
    },
    {
        label: 'Engineering and General Industry',
        value: 'engineering_industry',
    },
    {
        label: 'Engineering',
        value: 'engineering',
    },
    {
        label: 'Events',
        value: 'events',
    },
    {
        label: 'Financial',
        value: 'financial',
    },
    {
        label: 'Entertainment',
        value: 'entertainment',
    },
    {
        label: 'Government and Public Agencies',
        value: 'government',
    },
    {
        label: 'Games and Sports',
        value: 'games_and_sports',
    },
    {
        label: 'Hardware and Electronics',
        value: 'hardware',
    },
    {
        label: 'Technology',
        value: 'technology',
    },
    {
        label: 'Legal and Related',
        value: 'legal',
    },
    {
        label: 'Real Estate and Developers',
        value: 'real_estate',
    },
    {
        label: 'Industry and Manufacturing',
        value: 'industry',
    },
    {
        label: 'Media and Communication',
        value: 'media',
    },
    {
        label: 'Environment',
        value: 'environment',
    },
    {
        label: 'Fashion',
        value: 'fashion',
    },
    {
        label: 'Urban Mobility',
        value: 'urban_mobility',
    },
    {
        label: 'NGO / Third Sector',
        value: 'non_government',
    },
    {
        label: 'Health and Medicine',
        value: 'health',
    },
    {
        label: 'Autonomous Services via Apps',
        value: 'autonomous_app',
    },
    {
        label: 'Insurance',
        value: 'insurance',
    },
    {
        label: 'HR and Coaching Services',
        value: 'human_resources_and_coaching',
    },
    {
        label: 'Telecommunications',
        value: 'telecommunications',
    },
    {
        label: 'Tourism and Leisure',
        value: 'tourism',
    },
    {
        label: 'Retail',
        value: 'retail',
    },
    {
        label: 'Other',
        value: 'other',
    },
];
exports.MARKET_ES = [
    {
        label: 'Agroindustria',
        value: 'agribusiness',
    },
    {
        label: 'Abogacía y Legal',
        value: 'advocacy',
    },
    {
        label: 'Alimentos y bebidas',
        value: 'food',
    },
    {
        label: 'Consultoría',
        value: 'consultancy',
    },
    {
        label: 'Construcción civil',
        value: 'construction',
    },
    {
        label: 'Comunicación',
        value: 'communication',
    },
    {
        label: 'Educación y Enseñanza',
        value: 'education',
    },
    {
        label: 'Ingeniería e Industria General',
        value: 'engineering_industry',
    },
    {
        label: 'Ingeniería',
        value: 'engineering',
    },
    {
        label: 'Eventos',
        value: 'events',
    },
    {
        label: 'Financiero',
        value: 'financial',
    },
    {
        label: 'Capacitación',
        value: 'entertainment',
    },
    {
        label: 'Agencias Gubernamentales y Públicas',
        value: 'government',
    },
    {
        label: 'Juegos y Deportes',
        value: 'games_and_sports',
    },
    {
        label: 'Hardware y electrónica',
        value: 'hardware',
    },
    {
        label: 'Tecnología',
        value: 'technology',
    },
    {
        label: 'Legal y Afines',
        value: 'legal',
    },
    {
        label: 'Inmobiliarias y Desarrolladores',
        value: 'real_estate',
    },
    {
        label: 'Industria y manufactura',
        value: 'industry',
    },
    {
        label: 'Media y comunicación',
        value: 'media',
    },
    {
        label: 'Medio ambiente',
        value: 'environment',
    },
    {
        label: 'Moda',
        value: 'fashion',
    },
    {
        label: 'Mobilidad urbana',
        value: 'urban_mobility',
    },
    {
        label: 'ONG / Tercer Sector',
        value: 'non_government',
    },
    {
        label: 'Salud y Medicina',
        value: 'health',
    },
    {
        label: 'Servicios Autónomos Mediante Aplicación',
        value: 'autonomous_app',
    },
    {
        label: 'Seguro',
        value: 'insurance',
    },
    {
        label: 'Servicios de RR.HH. y Coaching',
        value: 'human_resources_and_coaching',
    },
    {
        label: 'Telecomunicaciones',
        value: 'telecommunications',
    },
    {
        label: 'Turismo y Ocio',
        value: 'tourism',
    },
    {
        label: 'Venta minorista',
        value: 'retail',
    },
    {
        label: 'Otro',
        value: 'other',
    },
];
//# sourceMappingURL=market.js.map